import React from 'react';
import { Card, Typography, Row, Col } from 'antd';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { PlanoAcaoStats } from '../../../../types/dashboard/fornecedores.types';

const { Title, Text } = Typography;

interface PlanosAcaoChartProps {
  data: PlanoAcaoStats;
}

const PlanosAcaoChart: React.FC<PlanosAcaoChartProps> = ({ data }) => {

  const totalFornecedores = data.totalFornecedores || 1;
  
  // Porcentagem de questionários respondidos (roxo)
  const percentualRespondidos = Math.min(100, Math.round((data.respostasObtidas / totalFornecedores) * 100));
  
  // Porcentagem de planos liberados (azul) - não deve exceder o percentual de questionários não respondidos
  const percentualLiberados = Math.min(
    Math.round((data.planosIniciados / totalFornecedores) * 100), 
    percentualRespondidos // Não pode haver mais planos liberados que questionários respondidos
  );
  
  // Porcentagem de espaço vazio (cinza) - o restante até 100%
  const percentualVazio = 100 - percentualRespondidos - percentualLiberados;
  
  console.log('Valores percentuais:', {
    respondidos: percentualRespondidos,
    liberados: percentualLiberados,
    vazio: percentualVazio,
    total: percentualRespondidos + percentualLiberados + percentualVazio
  });

  // Dados para o gráfico
  const chartData = [
    { name: 'Respondidos', value: percentualRespondidos, color: '#7B39DB' }, // Roxo
    { name: 'Liberados', value: percentualLiberados, color: '#39DBDB' }, // Azul turquesa
    { name: 'Vazio', value: percentualVazio, color: '#E0E0E0' } // Cinza claro
  ];

  return (
    <Card
      title={<Title level={4} style={{ margin: 0 }}>Planos de Ação</Title>}
      style={{ height: '100%', border: '2px solid black' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: 280 }}>
        {/* Legenda e valores ACIMA do gráfico */}
        <div style={{ width: '100%', marginBottom: 20 }}>
          <Row gutter={[16, 0]} justify="center">
            <Col>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                backgroundColor: '#f5f5f5', 
                padding: '8px 12px', 
                borderRadius: '4px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}>
                <div
                  style={{
                    width: 12,
                    height: 12,
                    backgroundColor: '#7B39DB',
                    borderRadius: '50%',
                    marginRight: 8
                  }}
                />
                <div>
                <Text strong style={{ fontSize: '14px' }}>Questionários Respondidos</Text>
                  <div><Text strong style={{ fontSize: '16px' }}>{data.respostasObtidas || 0}</Text> / {totalFornecedores}</div>
                </div>
              </div>
            </Col>
            <Col>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                backgroundColor: '#f5f5f5', 
                padding: '8px 12px', 
                borderRadius: '4px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}>
                <div
                  style={{
                    width: 12,
                    height: 12,
                    backgroundColor: '#39DBDB',
                    borderRadius: '50%',
                    marginRight: 8
                  }}
                />
                <div>
                <Text strong style={{ fontSize: '14px' }}>Planos Liberados para Ação</Text>
                  <div><Text strong style={{ fontSize: '16px' }}>{data.planosIniciados || 0}</Text></div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        
        {/* Gráfico de progresso circular */}
          <div style={{ position: 'relative', width: '100%', height: 200, clear: 'both' }}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={chartData}
                  cx="50%"
                  cy="50%"
                  innerRadius={45}
                  outerRadius={65}
                  startAngle={90}
                  endAngle={-270}
                  paddingAngle={0}
                  dataKey="value"
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          
          {/* Porcentagem no centro */}
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center'
            }}
          >
            <Title level={2} style={{ margin: 0, color: '#7B39DB' }}>
              {data.percentualConcluido || 0}%
            </Title>
            <Text type="secondary">Concluído</Text>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default PlanosAcaoChart;